import { Link } from 'react-router-dom';
import { Dropdown, Button } from 'react-bootstrap';

import Flex from '../../common/Flex';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import {
  faFileDownload,
} from '@fortawesome/free-solid-svg-icons';
import {
  faCircleQuestion,
  faEnvelope,
} from '@fortawesome/free-regular-svg-icons';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { getDocumentListByLinerAndCountry } from '../../../app/features/documentManagment/actions/DocumentMasterActions';
import { useDispatch } from 'react-redux';
import { encryptAndEncode } from '../../../encrypt-util';
import { openDocumentInNewTab } from '../../../helpers/openDocumentInNewTab';

const HelpDocDropDown = () => {
  const profileDetails = useSelector((state) => state.userProfile.profile);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const configList = useSelector((state) => state.helpDocument.documentList);
  const linerId = useSelector((state) => state.navbarTop.linerId)
  const language = useSelector((state) => state.navbarTop.language);
  // Filter configList to match selected language (default to EN if not set)
  console.log(configList,"<<configList")
  console.log(language,"<<language")
  const filteredConfigList = configList?.filter(
    (item) => (item.languageCode?.trim()) === language?.trim() && item.helpDocumentStatus==='1'
  );
  console.log(filteredConfigList,"<<filteredConfigList")
  useEffect(() => {
    if (linerId && profileDetails?.partnerCountry) {
      dispatch(getDocumentListByLinerAndCountry({
        liner: linerId,
        country: profileDetails?.partnerCountry
      }));
    }
  }, [linerId, profileDetails?.partnerCountry]);

  if (profileDetails?.partnerType !== 'customer' || configList?.length < 1) return <></>

  return (
    <Dropdown navbar={true} as='li'>
      <Dropdown.Toggle
        bsPrefix='toggle'
        as={Link}
        to='#!'
        className='pe-0 ps-2 nav-link '>
        <Flex
          direction={'row'}
          justifyContent='end'
          alignItems={'center'}
          alignContent=''
          inline=''
          wrap=''
          className=''
          children=''
          breakpoint=''>

          <Button
            style={{ width: '105px' }}
            variant='ms-3 btn btn-falcon-primary z-inxe-agent btn-sm'
            size='lg'
            title='Help Document'
            className='ms-3'>
            <FontAwesomeIcon
              icon={faCircleQuestion}
              className='me-2 '
              style={{ fontSize: '14px', color: '#f5822a' }}
              title='Help Document'
            />
            <span>{t('resource_1:help')}</span>
          </Button>
        </Flex>
      </Dropdown.Toggle>
      <Dropdown.Menu className='dropdown-caret dropdown-menu-card dropdown-menu-end'>
        <div className='bg-white rounded-2 py-2 dark__bg-1000'>

          {filteredConfigList.map((item, index) =>
            item.support ?
              <Dropdown.Item onClick={() => {
                navigator.clipboard.writeText(item.support)
                toast('Copied to clipboard')
              }}>
                <div class='row g-2 align-items-sm-center'>
                  <div class='col-auto'> Support Mail</div>
                  <div class='col'>
                    <div class='row align-items-center'>
                      <div class='col col-lg-8'>
                        <span style={{ fontSize: '16px !important' }}>

                          <FontAwesomeIcon
                            icon={faEnvelope}
                            className='me-2 '
                            style={{
                              fontSize: '16px !important',
                              color: '#f5822a',
                            }}
                            title='Support Mail'
                          />
                        </span>
                        <span class='fs-0 mb-3 mb-sm-0 text-primary'>
                          {item.support}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Dropdown.Item>
              : <>
                {index != 0 && <Dropdown.Divider />}
                <Dropdown.Item style={{ cursor: 'default' }}>
                  <div className='d-flex flex-row bd-highlight  justify-content-between'>
                    <div className='me-3'>{item.title} {' '}</div>
                    <div style={{ alignSelf: 'flex-end' }}>
                      <span>&nbsp; &nbsp; &nbsp; &nbsp;</span>
                      {item.video?.length > 0 &&
                        <span onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          const url = item.video.startsWith('http') ? item.video : `https://${item.video}`;
                          window.open(url, '_blank', 'noreferrer');
                        }}
                          style={{ cursor: 'pointer' }}
                        >
                          <FontAwesomeIcon icon={faYoutube} className='me-2' />
                        </span>
                      }

                      {item.pdf?.length > 0 &&
												<span
												  onClick={async () => {
												    await openDocumentInNewTab({
												      url: '/api/master/v1/common/openDocument',
												      params: {
												        id: encryptAndEncode(item.mstHelpDocumentId),
												        moduleTp: 'HELP_DOC',
												        linerId: encryptAndEncode(item.linerId),
												      },
												    });
												  }}
												  to={''}
                          style={{ cursor: 'pointer' }}>
                          <FontAwesomeIcon icon={faFileDownload} className='me-2' />
                        </span>
                      }

                    </div>
                  </div>
                </Dropdown.Item>
              </>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )
};

export default HelpDocDropDown;
